'use client';

import { Badge } from '@repo/ui/components/ui/badge';
import { EmptyValue } from './empty-value';
import { Field } from '../../types';

interface MultiselectValueProps {
  value: string[];
  options: { id: string; label: string }[];
}

export function MultiselectValue({ value, options }: MultiselectValueProps) {
  let currentValues: string[] = Array.isArray(value) ? value : [];


  if (currentValues.length === 0) {
    return <EmptyValue message="Aucune sélection" />;
  }


  return (
    <div className="flex flex-wrap gap-2">
      {currentValues.map((val) => {
        const option = options.find(opt => opt.id?.toString()?.toLowerCase() === val?.toString()?.toLowerCase());

        return (
          <Badge
            key={val}
            variant="secondary"
            className="border-border/40 bg-muted/50 px-2.5 py-1 text-[13px] font-medium shadow-sm dark:border-border/30"
          >
            {option?.label || val}
          </Badge>
        );
      })}
    </div>
  );
}

